


































































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class ForgotPasswView extends Mixins(FormValidator) {
  email: string = "";
  bin: string = "";
  error: boolean = false;
  formRef = "form";
  loading: boolean = false;
  public async runRestorePassw() {
    if (!this.validateForm()) return;
    try {
      this.loading = true;
      const result = await AuthModule.restorePassword({
        email: this.email,
        bin: this.bin.toString(),
      });
      if (result.success) {
        this.error = false;
        this.$router.push("/warningRestore");
      } else {
        this.error = true;
      }
    } finally {
      this.loading = false;
    }
  }
  public async clickBack() {
    await AuthModule.setEnter_types(1);
    this.$router.push("/auth");
  }
}
